import { useMemo } from 'react';
import { MenuSection, NavigationItem } from '../types';

export default function useNavigationItems(navigation: NavigationItem[]) {
  return useMemo(() => {
    const menuHeaders = navigation.filter(
      (item): item is NavigationItem & { title: string; sections: MenuSection[] } =>
        item._type === 'menuHeader' && !!item.title && !!item.sections,
    );

    return { menuHeaders };
  }, [navigation]);
}
